import React from "react";
import { RaisedButton, TextField, Styles } from "material-ui";
import { Navigation } from "react-router";
import Helmet from "react-helmet";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonActions from "../actions/PersonActions";
import PersonStore from "../stores/PersonStore";

@connectToStores
class Reset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      confirmPassword: ""
    };

    this._reset = this._reset.bind(this);
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired
    };
  }

  _reset() {
    PersonActions.resetPassword(
      this.props.location.query.token,
      this.state.password
    );
  }

  getStyles() {
    return {
      container: {
        margin: "20px auto",
        marginTop: "10%",
        width: 270,
        fontSize: "11pt"
      },
      actions: {
        marginTop: 10,
        textAlign: "center"
      },
      error: {
        color: "#FF4136"
      }
    };
  }

  render() {
    var styles = this.getStyles();

    return (
      <div style={styles.container}>
        <Helmet title="Reset password" />
        {this.props.resetSuccess ? (
          <div>
            <p>Password reset successfully! Please login again.</p>
            <div style={styles.actions}>
              <RaisedButton
                label="Return to login"
                style={{ marginLeft: 12 }}
                onClick={() => this.context.router.push("/login")}
              />
            </div>
          </div>
        ) : (
          <div>
            {this.props.resetErrorMessage ? (
              <p style={styles.error}>
                Failed to reset password: {this.props.resetErrorMessage}
              </p>
            ) : (
              <p>Almost there&mdash;please enter a new password.</p>
            )}
            <form>
              <div>
                <TextField
                  hintText="New password"
                  value={this.state.password}
                  onChange={e => this.setState({ password: e.target.value })}
                  type="password"
                  disabled={this.props.resetInProgress}
                />
              </div>
              <div>
                <TextField
                  hintText="Confirm new password"
                  value={this.state.confirmPassword}
                  onChange={e =>
                    this.setState({ confirmPassword: e.target.value })
                  }
                  errorText={
                    this.state.password !== this.state.confirmPassword
                      ? "The passwords do not match."
                      : null
                  }
                  type="password"
                  disabled={this.props.resetInProgress}
                />
              </div>
              <div style={styles.actions}>
                <RaisedButton
                  label={
                    this.props.resetInProgress
                      ? "Resetting..."
                      : "Reset password"
                  }
                  disabled={
                    this.props.resetInProgress ||
                    !this.state.password ||
                    this.state.password !== this.state.confirmPassword
                  }
                  primary={true}
                  onClick={this._reset}
                />
              </div>
            </form>
          </div>
        )}
      </div>
    );
  }
}

export default Reset;



// WEBPACK FOOTER //
// ./src/app/components/reset.jsx